import Vue from 'vue'
import VueRouter from 'vue-router'
import PcIndex from '../views/pc_index'
// import chats from '../views/chats'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '',
  //   redirect: '/discovery'
  // },  
  //path设置如 /home 服务器找不到文件，需要配置伪静态
  {
    path: '',
    name: 'index',
    component: PcIndex
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  base: '/2022postdoctor'
  // base: '/'
})

export default router
